import { Wind, Sparkles, Shield, CheckCircle2 } from "lucide-react";

const SERVICES = [
  { id: "duct", icon: Wind, title: "Air Duct Cleaning", body: "HEPA negative-air vacuum and rotary brush agitation across every trunk line, supply, and return." },
  { id: "dryer", icon: Sparkles, title: "Dryer Vent Cleaning", body: "Prevent fires and shorten dry times. We clean the full vent path from drum to roof cap." },
  { id: "sanitize", icon: Shield, title: "Sanitization", body: "EPA-registered antimicrobial fogging to neutralize mold, bacteria, and odor at the source." },
  { id: "coil", icon: CheckCircle2, title: "Coil & System Tune-up", body: "Evaporator coil cleaning and blower inspection — restore airflow and lower energy bills." },
];

const SPAN_BY_ID = {
  duct: "md:col-span-6 lg:col-span-7",
  dryer: "md:col-span-6 lg:col-span-5",
  sanitize: "md:col-span-6 lg:col-span-5",
  coil: "md:col-span-6 lg:col-span-7",
};

export default function ServicesBento() {
  return (
    <section className="section-pad" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-12">
          <div className="md:col-span-7">
            <div className="eyebrow mb-3">What we do</div>
            <h2 className="font-heading text-4xl md:text-5xl tracking-tight font-medium">
              A whole-home approach to indoor air.
            </h2>
          </div>
          <p className="md:col-span-5 text-muted2 leading-relaxed">
            We don't just blow dust around. Our 7-step process pulls debris under negative pressure,
            agitates with rotary brushes, and finishes with optional antimicrobial fogging.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.id} className={`${SPAN_BY_ID[s.id]} card-surface p-8 hover-lift`} data-testid={`service-card-${s.id}`}>
                <div className="flex items-start gap-5">
                  <span className="inline-flex w-11 h-11 rounded-full bg-forest/8 text-forest items-center justify-center shrink-0">
                    <Icon size={20} strokeWidth={1.5} />
                  </span>
                  <div>
                    <h3 className="font-heading text-2xl tracking-tight">{s.title}</h3>
                    <p className="mt-2 text-muted2 leading-relaxed">{s.body}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
